/**
 * 要素の縦スクロールを横スクロールに変換し、限界までスクロールしたら通常スクロールを許可する
 * @param {HTMLElement} element - 横スクロールさせたい要素
 * @param {number} speedMultiplier - スクロール速度の倍率
 * @example
 * const scrollContainer = document.querySelector('.scroll-container');
 * if (scrollContainer instanceof HTMLElement) {
 *   convertVerticalToHorizontalScroll(scrollContainer, 0.5);
 * }
 */
const convertVerticalToHorizontalScroll = (
    element,
    speedMultiplier = 1,
    onScroll = (e) => {}
) => {
    element.addEventListener("wheel", (event) => {
        const isScrollingRight = event.deltaY > 0;
        const isScrollingLeft = event.deltaY < 0;

        const currentScroll = element.scrollLeft;
        const maxScroll = element.scrollWidth - element.clientWidth - 10;

        const shouldPreventScroll =
            (isScrollingRight && currentScroll < maxScroll) ||
            (isScrollingLeft && currentScroll > 0);

        if (shouldPreventScroll) {
            event.preventDefault();
            element.scrollLeft += event.deltaY * speedMultiplier;
        }
        onScroll(event);
    });
};

/**
 * 指定した範囲の値を0から1に正規化するよ！
 * @param value 正規化したい値
 * @param min 入力値の最小値
 * @param max 入力値の最大値
 * @returns 正規化された値（0から1の範囲）
 * @example
 * normalize(-129, -129, 110); // 0
 * normalize(0, -129, 110);    // 0.5416666666666666
 * normalize(110, -129, 110);  // 1
 */
export const normalize = (value, min, max) => {
    // 正規化の計算式
    return (value - min) / (max - min);
};

/**
 * スクロールに応じて要素のアニメーションを制御する関数だよ！
 * @param {ScrollAnimationOptions} options - アニメーションの設定オプション
 *
 * @example
 * // セレクターで指定する場合
 * initScrollAnimation({
 *   bg: ".future__imgBg",
 *   onChange: (progress) => {
 *     const bg = document.querySelector(".future__imgBg");
 *     bg.style.translate = `${(1 - progress) * -100}% 0`;
 *   }
 * });
 *
 * // HTML要素で直接指定する場合
 * const myElement = document.querySelector(".my-element");
 * initScrollAnimation({
 *   bg: myElement,
 *   onChange: (progress) => {
 *     myElement.style.opacity = String(progress);
 *   }
 * });
 */
const initScrollAnimation = ({
    bg,
    minHeight = 0.3,
    maxHeight = 1,
    onChange,
}) => {
    const targetElement =
        typeof bg === "string" ? document.querySelector(bg) : bg;

    if (!targetElement) {
        console.error("対象の要素が見つからないよ！確認してね！");
        return;
    }

    const min = innerHeight * minHeight;
    const max = innerHeight * maxHeight;

    // アニメーション開始フラグを追加
    let isAnimationStarted = false;

    const handleScroll = () => {
        let progress = 0;
        const bgInfo = targetElement.getBoundingClientRect();

        if (bgInfo.top < min) {
            progress = 0;
        } else if (bgInfo.top > max) {
            progress = 1;
        } else {
            progress = normalize(bgInfo.top, min, max);
        }

        if (progress < 1 && !isAnimationStarted) {
            targetElement.classList.add("is-started");
            isAnimationStarted = true;
        }

        onChange(progress);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
        window.removeEventListener("scroll", handleScroll);
    };
};

/**
 * イーズアウト関数 - 三次関数バージョン（より滑らか）
 * @param t 現在の進行度（0から1の間）
 * @returns 計算された位置（0から1の間）
 * @example
 * // 使用例
 * const position = easeOutCubic(0.5); // 0.875が返される
 */
const easeOutCubic = (t) => {
    return 1 - Math.pow(1 - t, 3);
};

/**
 * カスタマイズ可能なイーズアウト関数
 * @param t 現在の進行度（0から1の間）
 * @param power べき乗の値（大きいほど減速感が強くなる）
 * @returns 計算された位置（0から1の間）
 * @example
 * // 使用例
 * const position1 = customEaseOut(0.5, 2);  // 通常の二次関数
 * const position2 = customEaseOut(0.5, 4);  // よりドラマチックな減速
 * const position3 = customEaseOut(0.5, 1.5); // より緩やかな減速
 */
const customEaseOut = (t, power = 2) => {
    return 1 - Math.pow(1 - t, power);
};

if (document.body.classList.contains("history")) {
    document.querySelectorAll(".simplebar-content-wrapper").forEach((el) => {
        convertVerticalToHorizontalScroll(el);
    });

    (() => {
        let isFinished = false;
        initScrollAnimation({
            bg: ".future__imgBg",
            onChange: (progress) => {
                if (!isFinished) {
                    const bg = document.querySelector(".future__imgBg");
                    const img = document.querySelector(
                        ".future__img figure img"
                    );
                    bg.style.translate = `${
                        (1 - customEaseOut(progress, 1.5)) * 100
                    }% 0`;
                    img.style.scale = `${1 + 0.1 * progress}`;

                    if (progress <= 0) {
                        isFinished = true;
                    }
                }
            },
        });
    })();
}

if (
    document.body.classList.contains("page-business-0") ||
    document.body.classList.contains("home")
) {
    const imgs = document.querySelectorAll(
        ".Workposts__postImgs figure,.Workposts__postRight a figure"
    );

    const imgCells = document.querySelectorAll(
        ".Workposts__postImgs,.Workposts__postRight"
    );

    window.addEventListener("load", () => {
        if (innerWidth > 1024) {
            //pc用
            imgs.forEach((img) => {
                let isFinished = false;

                initScrollAnimation({
                    bg: img,
                    minHeight: 0.35,
                    maxHeight: 0.8,
                    onChange: (progress) => {
                        if (!isFinished) {
                            const bg = img.querySelector("span.bg");
                            const imgtag = img.querySelector("img");
                            bg.style.translate = `${
                                (1 - easeOutCubic(progress)) * 100
                            }% 0`;
                            imgtag.style.scale = `${1 + 0.1 * progress}`;
                            if (progress <= 0) {
                                isFinished = true;
                            }
                        }
                    },
                });
            });
        } else {
            //sp用
            imgCells.forEach((img) => {
                let isFinished = false;

                const offset = img.getBoundingClientRect().height / innerHeight;

                const figs = img.querySelectorAll("figure");
                initScrollAnimation({
                    bg: img,
                    minHeight: document.body.classList.contains(
                        "page-business-0"
                    )
                        ? 0.3
                        : Math.max(0.25, 0.65 - offset),
                    maxHeight: document.body.classList.contains(
                        "page-business-0"
                    )
                        ? 0.9
                        : Math.max(0.5, 1 - offset),
                    onChange: (progress) => {
                        if (!isFinished) {
                            figs.forEach((fig) => {
                                const bg = fig.querySelector("span.bg");
                                const imgtag = fig.querySelector("img");
                                bg.style.translate = `${
                                    (1 - easeOutCubic(progress)) * 100
                                }% 0`;
                                imgtag.style.scale = `${1 + 0.1 * progress}`;
                            });

                            if (progress <= 0) {
                                isFinished = true;
                            }
                        }
                    },
                });
            });
        }
    });
}

if (document.body.classList.contains("home")) {
    const imgs = document.querySelectorAll(".his__yearsYear");

    imgs.forEach((img) => {
        initScrollAnimation({
            bg: img,
            minHeight: 0.35,
            maxHeight: 0.8,
            onChange: (progress) => {},
        });
    });
}
